import { SECTION } from '@aytm/app/stats/page/data-quality-report/lib/sections'

// Quality figures the sticky header shows on the Data Quality Report tab, read off the same
// /dqr report the report body renders from. A layer that has not landed yet (the sentinel pass is
// null until it runs; humanReview until the survey is fielded) reads null, which the header dashes:
// a zero here would state a measurement the section itself declines to make. A real zero survives.
export const toHeaderStats = report => {
  const humanReview = report?.sections?.[SECTION.HUMAN_REVIEW] || {}
  const sentinel = report?.sections?.[SECTION.TRAFFIC_SENTINEL]?.sentinel

  return {
    // Human-oversight rejections (expert removals + client OE) — the count the Human Review
    // section reports. DC auto-quarantines are the Data Centrifuge section's number, not this one.
    rejectedCount: humanReview.totalRejectedCount ?? null,
    blockedCount: sentinel ? sentinel.totalBlocked || 0 : null
  }
}
